import dayjs, { Dayjs } from 'dayjs';

export type PopupType = {
  img: string;
  size: number;
  link?: string;
  type?: '_blank';
  default: boolean;
  date?: {
    start: Dayjs;
    end: Dayjs;
  };
};

export const popupList: PopupType[] = [
  {
    img: process.env.PUBLIC_URL + 'images/home/popup/20260210.jpg',
    size: 480,
    default: false,
    date: {
      start: dayjs('2026-02-13'),
      end: dayjs('2026-02-18'),
    },
  },
  // {
  //   img: process.env.PUBLIC_URL + 'images/home/popup/20250909.jpg',
  //   link: 'https://blog.naver.com/jebs_jemm/223992240529',
  //   size: 480,
  //   default: false,
  //   date: {
  //     start: dayjs('2025-09-15'),
  //     end: dayjs('2025-09-28'),
  //   },
  // },
  // {
  //   img: process.env.PUBLIC_URL + 'images/home/popup/20250929.png',
  //   size: 480,
  //   default: false,
  //   date: {
  //     start: dayjs('2025-09-27'),
  //     end: dayjs('2025-10-12'),
  //   },
  // },
  // {
  //   img: process.env.PUBLIC_URL + 'images/home/popup/20240716.jpg',
  //   link: 'https://jebs-notice.oopy.io/3445e325-9c88-40d5-a77f-a862a8e46af5',
  //   size: 480,
  //   default: true,
  // },
  // {
  //   img: process.env.PUBLIC_URL + 'images/home/popup/20250523.png',
  //   size: 480,
  //   default: false,
  //   date: {
  //     start: dayjs('2025-05-23'),
  //     end: dayjs('2025-05-26'),
  //   },
  // },
];
